import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Collection, DevBar } from '@eti/debug';
import { useTranslation } from '@eti/providers';
import { isDev } from '../../debug/utils';
import { DebugCommonComponents } from '../../debug/components';
import RyanairLogin from '../components/RyanairLogin';
import Login from '../components/Login';

interface LoginContainerProps {
  isRyanairOrder?: boolean;
}

const LoginContainer = ({ isRyanairOrder = false }: LoginContainerProps) => {
  const { t } = useTranslation();
  const [notification, setNotification] = useState<{
    message: string;
    type: string;
    dataTestId: string;
  } | null>(null);

  return (
    <>
      <Helmet title={t('PageTitle.rf.order.authentication.action')} />
      {isRyanairOrder ? (
        <RyanairLogin notification={notification} setNotification={setNotification} />
      ) : (
        <Login notification={notification} setNotification={setNotification} />
      )}

      {isDev && (
        <DevBar>
          <Collection>
            <DebugCommonComponents />
          </Collection>
        </DevBar>
      )}
    </>
  );
};

export default LoginContainer;
